export const subscriptionLteBillingComponent = {
  key: 'subscriptionLteBillingComponent',
  name: 'Subscription Lte Billing - Dept-Component',
  siteIdentifier: 'global',

  nextBillingDateLabel: 'Next Billing Date',
  serviceExpiredLabel: 'Service Expired',
  serviceExpiresLabel: 'Service Expires',
};
